// ===================================================
// Проверка прав «подключённой компании» (server-derived)
// Должна совпадать с markbase.ru/backend/src/middleware/auth.js:
//   parsePermission, actionToPermFlag, ветка isPrimaryCompany === false в checkPermission.
// ===================================================

/** @type {Record<string, { resource: string, action: string }>} */
const LEGACY_PERMISSION_MAP = {
  SUPPLIERS_MANAGE: { resource: 'suppliers', action: 'update' },
  SUPPLIERS_SYNC: { resource: 'suppliers', action: 'update' },
  PRODUCTS_MANAGE: { resource: 'products', action: 'update' },
  WAREHOUSES_MANAGE: { resource: 'warehouses', action: 'update' },
  USERS_MANAGE: { resource: 'users', action: 'update' },
};

/**
 * @param {string} requiredPermission — напр. 'products.view', 'settings.update', 'file-import.view'
 * @returns {{ resource: string, action: string }}
 */
export function parsePermission(requiredPermission) {
  if (!requiredPermission) {
    return { resource: '', action: '' };
  }
  if (String(requiredPermission).includes('.')) {
    const [resource, action] = String(requiredPermission).split('.');
    return {
      resource: String(resource || '').toLowerCase(),
      action: String(action || '').toLowerCase(),
    };
  }
  const mapped = LEGACY_PERMISSION_MAP[requiredPermission];
  if (mapped) {
    return { resource: String(mapped.resource).toLowerCase(), action: String(mapped.action).toLowerCase() };
  }
  const parts = String(requiredPermission)
    .toLowerCase()
    .split('_')
    .filter(Boolean);
  return { resource: parts[parts.length - 1] || parts[0] || '', action: 'view' };
}

/**
 * Маппинг action → флаги в `connectionPermissions[resource]`
 * @param {string} action
 * @returns {'read'|'create'|'update'|'delete'}
 */
export function actionToPermFlag(action) {
  if (action === 'view' || action === 'read' || action === 'list' || action === 'get') return 'read';
  if (action === 'create') return 'create';
  if (action === 'update' || action === 'edit' || action === 'manage') return 'update';
  if (action === 'delete' || action === 'remove') return 'delete';
  return 'read';
}

/**
 * Разрешает ли объект прав подключённой компании строку `products.view` и т.п.
 * @param {string} requiredPermission
 * @param {Record<string, unknown>|null|undefined} connectionPermissions
 */
export function connectionPermissionsAllow(requiredPermission, connectionPermissions) {
  if (!requiredPermission) return false;
  const perms = connectionPermissions && typeof connectionPermissions === 'object' ? connectionPermissions : {};
  if (perms.all === true) {
    return true;
  }
  const { resource, action } = parsePermission(requiredPermission);
  if (!resource) return false;
  const flag = actionToPermFlag(action);
  return Boolean(perms[resource]?.[flag]);
}
